module.exports = __webpack_public_path__ + "static/media/1274_CareTeam7_photo.408d34f8.png";